import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { mapTo, Observable, Subject, takeUntil, tap } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';
import { BypassInterceptorContext } from '../interceptors/http.interceptor';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private destroy$ = new Subject<void>();
  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    public baseService: BaseService
  ) {}

  refreshToken(): Observable<void> {
    const refreshToken = localStorage.getItem('refresh-token');

    if (!refreshToken) {
      console.error('No refresh token found in localStorage');
      return new Observable<void>((observer) => {
        observer.complete();
      });
    }

    const params = { refresh_token: refreshToken };

    const baseUrl = environment.SWITCH_URL
        const endPoint = '/user/api/v1/auth/refresh-token';
        const apiUrl = baseUrl + endPoint;
    
        const token = localStorage.getItem('auth-token');
    
        const headers = new HttpHeaders({
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        });
    
    const context = new HttpContext().set(BypassInterceptorContext, true);
    return this.http
      .post(apiUrl, params, { headers, context })
      .pipe(
        tap(
          (res: any) => {
            if (res?.data) {
              localStorage.setItem('auth-token', res.data.access_token);
              localStorage.setItem('refresh-token', res.data.refresh_token);
            }
          }
        ),
        mapTo(void 0)
      );
  }

  logout() {
    this.localStorageService.signOut();
  }
}
